import { Box, styled } from "@mui/material";

const CardContentSecondary = styled(Box)(({ theme }) => ({
  background: "#F5F5F5",
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
}));

export default CardContentSecondary
